import { Recurso, UseCaseRecursoAsync } from 'lib.common/dist/CleanArch';
import { ErrDevGenerico } from 'lib.common/dist/errorHandler';
import { DataLlave, EstadisticasLlave, EstadoLlaveAnual, ResumenLlaveByClienteProductoUsuario } from '../entities/EstadisticasLlave.entity';
import { FechaParams } from '../../utils/params/EstadisticasDsKey.params';
import { EstadisticasDsKeyRepository } from '../repository/EstadisticasDsKeyRepository';

export class GetResumenLlavesUseCase<
    T_OUT extends EstadisticasLlave,
    T_OUT2 extends DataLlave,
    T_OUT3 extends EstadoLlaveAnual,
    T_OUT4 extends ResumenLlaveByClienteProductoUsuario
> extends UseCaseRecursoAsync<
    FechaParams,
    T_OUT4[]
> {
    private repository: EstadisticasDsKeyRepository<T_OUT, T_OUT2, T_OUT3, T_OUT4>;
    constructor(repository: EstadisticasDsKeyRepository<T_OUT, T_OUT2, T_OUT3, T_OUT4>) {
        super();
        this.repository = repository;
    }

    async call(input: FechaParams): Promise<Recurso<T_OUT4[]>> {
        try {
            return this.repository.getResumenLlaves(input);
        } catch (error) {
            const errorCapa = new ErrDevGenerico(error as Error);
            return Recurso.fromError<T_OUT4[]>(errorCapa);
        }
    }
}